import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { useContext, useState, useEffect, useRef } from 'react';
import RestaurantContext from '../Context/RestaurantContext';
import CartContext from '../Context/CartContext';
import { ServiceType } from './UtilComponents/ServiceType';
import getStatusDataByServiceType from './UtilComponents/statusType';

const BadgeWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.warning};
  color: RGB(255, 255, 255);
  font-size: 14px;
  opacity: 0.9;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 6px 7px;
  position: fixed;
  z-index: 4;
  box-shadow: 0 2px 9px 0 rgba(120, 130, 140, 0.13);
`;

const CounterString = styled.p`
  font-size: 12px;
  font-weight: 400;
  border-left: solid 1px ${(props) => props.theme.colors.warning};
  padding-left: 11px;
  margin-top: 10px;
  margin-bottom: 0px;

  & > span {
    color: ${(props) => props.theme.colors.warning};
    font-weight: 700;
  }
`;

function ClosingTimeCounter({ variant, serviceType }) {
  const {
    restaurantProps,
    setIsClosedByLastMoment,
    minutesUntilLastMomentSinceRefetch,
  } = useContext(RestaurantContext);

  const { refetchDeliveryTimes } = useContext(CartContext);

  const [lastMinutes, setLastMinutes] = useState(0);
  const interval = useRef(null);

  const statusData = getStatusDataByServiceType(restaurantProps, serviceType);

  function calcLastMinutes() {
    if (!statusData?.payload?.lastMoment) return 0;
    const closingTime = new Date(statusData.payload.lastMoment).setSeconds(0, 0);
    return Math.ceil((closingTime - Date.now()) / 60000);
  }

  useEffect(() => {
    refetchDeliveryTimes();
    const initialMinutes = calcLastMinutes();
    setLastMinutes(initialMinutes);

    if (initialMinutes > 0 && initialMinutes < 31) {
      if (interval.current) {
        clearInterval(interval.current);
      }
      interval.current = setInterval(() => {
        const newMinutes = calcLastMinutes();
        if (newMinutes <= 0) {
          setLastMinutes(newMinutes);
          setIsClosedByLastMoment(true);
        } else {
          setLastMinutes(newMinutes);
        }
      }, 6000);
    }

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [
    minutesUntilLastMomentSinceRefetch,
    statusData?.payload?.lastMoment,
    setIsClosedByLastMoment,
    refetchDeliveryTimes,
  ]);

  useEffect(() => {
    if (lastMinutes <= 0 && interval.current) {
      clearInterval(interval.current);
    }
  }, [lastMinutes]);

  const singleServiceStatus = statusData?.status || '';
  const showCounter =
    lastMinutes > 0 && lastMinutes < 31 && singleServiceStatus === 'OPEN';

  if (!showCounter) {
    return null;
  }

  return (
    <>
      {lastMinutes > 0 && lastMinutes < 31 && statusData.status === 'OPEN' ? (
        <>
          {variant === 'menu' ? (
            <BadgeWrapper>
              noch <span style={{ fontWeight: 700 }}>{lastMinutes}</span> min
            </BadgeWrapper>
          ) : (
            <CounterString>
              Das Restaurant hat nur noch{' '}
              <span>
                {lastMinutes} Minute{lastMinutes > 1 && 'n'}
              </span>{' '}
              geöffnet{' '}
            </CounterString>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
}

ClosingTimeCounter.propTypes = {
  variant: PropTypes.string,
  serviceType: PropTypes.oneOf(Object.values(ServiceType)).isRequired,
};

export default withTheme(ClosingTimeCounter);
